import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import RegisterPage from "./auth/RegisterPage";
import SuperAdminLogin from "./auth/SuperAdminLogin";
import AuthRoutes from "./routes/AuthRoutes";
import DashboardRoutes from "./routes/DashboardRoutes";

const AppRoutes = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/auth/*" element={<AuthRoutes />} />
        <Route path="/dashboard/*" element={<DashboardRoutes />} />
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/admission-form" element={<RegisterPage />} />
        <Route path="/super-admin" element={<Navigate to="/super-admin/login" replace />} />
        <Route path="/super-admin/login" element={<SuperAdminLogin />} />
      </Routes>
    </BrowserRouter>
  );
};

export default AppRoutes;
